<template>
  <div class="eat-list no-scrollbar" :class="$store.state.theme">
    <fade-transition>
      <div v-show="isBottom" class="add-it" @click="shopSignUpForm">
        <span class="cannot-find">{{ $t("shop.cannot-find") }}</span>
        <i class="cannot-find link">{{ $t("shop.add-it") }}</i>
      </div>
    </fade-transition>

    <div class="shops-wrapper no-scrollbar gpu-accelerated" v-on:scroll.passive="checkScrollBottom" ref="scrollable">
      <div v-show="noBusinesses" class="card">
        <div class="card-content" style="padding: 18px" @click="tryAgain">
          <p style="margin-bottom: 9px">
            <span class="no-businesses has-text-grey">
              {{ $t("shop.search-no-shop") }}
            </span>
            <i class="no-businesses link">{{ $t("try-again") }}</i>
          </p>
        </div>
      </div>

      <div style="padding-bottom: 100px">
        <div v-if="!openBusinesses.length && !noBusinesses" class="card">
          <div class="card-content" style="padding: 18px" @click="tryAgain">
            <p style="padding-bottom: 10px">
              <span class="no-businesses has-text-grey">{{ $t("Nearby shops are closed now") }} &nbsp;<i
                  class="far fa-clock" /></span>
            </p>
          </div>
        </div>

        <div class="card shop-card" v-for="b in openBusinesses" :key="b.id" :ref="b.id" @click="openShopPage(b.id)">
          <div class="card-content" style="padding: 6px">
            <div class="media" style="margin-bottom: 0">
              <div class="media-left">
                <figure class="image">
                  <img v-webp="businessProfilePic(b)" @error="defaultImg" />
                </figure>
              </div>
              <div class="media-content">
                <p class="shop-name">{{ shortName(b) }}</p>
                <div class="is-flex" style="gap: 3px">
                  <div v-if="b.data.product_pic_url" style="flex: 0 0 auto; height: 63px">
                    <img class="small-img" v-webp="b.data.product_pic_url" />
                  </div>
                  <div style="flex-grow: 1; margin-top: 2px">
                    <p class="categories single-line no-scrollbar">
                      {{ categoryList(b) }}
                    </p>
                    <p class="special-tags">
                      <span v-if="b.data.award" class="icon">
                        <i class="fa fa-certificate has-text-info" />
                      </span>
                      <span v-for="s in specialTags(b)" :key="s" class="special-tag">{{ s }}</span>
                    </p>
                    <p class="bottom-tags">
                      <span v-if="isFreeDelivery(b)" class="free-delivery-tag">{{
                        $t("delivery.delivery-promo")
                      }}</span>
                      <span v-else-if="isDelivery(b)" class="delivery-tag">{{
                        $t("commerce.delivery")
                      }}</span>
                    </p>
                  </div>
                </div>
                <!-- top-left corner -->
                <span v-if="isFavorite(b.id)" class="icon heart">
                  <i class="fas fa-heart has-text-danger" />
                </span>
                <!-- <span class="top-left-corner">
                  <span
                    v-for="s in specialTags(b)"
                    :key="s"
                    class="special-tag"
                    >{{ s }}</span
                  >
                  <span v-if="b.data.award" class="icon">
                    <i class="fa fa-certificate has-text-info" />
                  </span>
                </span> -->
                <span v-if="b.distance" class="distance" :class="distanceColor(b.distance)">
                  <span>{{ b.prettyDistance }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!noBusinesses" class="open-closed-separator" style="overflow: hidden">
          <span class="has-text-grey">
            <span style="width: 30px; display: inline-block; text-align: center">
              <i class="fa fa-chevron-up" />
            </span>
            {{ $t("shop.open-now") }}
          </span>
          <span class="is-pulled-right has-text-grey" @click="showClosed = !showClosed">
            {{ $t("shop.closed-now") }}
            <span style="width: 30px; display: inline-block; text-align: center">
              <i v-show="showClosed" class="fa fa-chevron-down" />
              <span v-show="!showClosed" class>({{ closedBusinesses.length }})</span>
            </span>
          </span>
        </div>

        <div v-if="showClosed">
          <div class="card shop-card" style="background-color: #eee" v-for="b in closedBusinesses" :key="b.id"
            :ref="b.id" @click="openShopPage(b.id)">
            <!-- v-webp:bg="bannerPic(b)" -->
            <div class="card-content" style="padding: 6px">
              <!-- <i v-if="businessIsOpenNow(b)" class="indicator open" />
              <i v-else class="indicator closed" /> -->
              <div class="media" style="margin-bottom: 0">
                <div class="media-left">
                  <figure class="image">
                    <img v-webp="businessProfilePic(b)" @error="defaultImg" />
                  </figure>
                  <div class="closed-banner">{{ $t("shop.closed") }}</div>
                </div>
                <div class="media-content">
                  <p class="shop-name">{{ shortName(b) }}</p>
                  <div class="is-flex" style="gap: 3px">
                    <div v-if="b.data.product_pic_url" style="flex: 0 0 auto">
                      <img class="small-img" v-webp="b.data.product_pic_url" />
                    </div>
                    <div style="flex-grow: 1; margin-top: 2px">
                      <p class="categories single-line no-scrollbar">
                        {{ categoryList(b) }}
                      </p>
                      <p class="special-tags">
                        <span v-if="b.data.award" class="icon">
                          <i class="fa fa-certificate has-text-info" />
                        </span>
                        <span v-for="s in specialTags(b)" :key="s" class="special-tag">{{ s }}</span>
                      </p>
                      <p>
                        <span v-if="isFreeDelivery(b)" class="free-delivery-tag">{{
                          $t("delivery.delivery-promo")
                        }}</span>
                        <span v-else-if="hasDelivery(b)" class="delivery-tag">{{
                          $t("commerce.delivery")
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <span v-if="isFavorite(b.id)" class="icon heart">
                    <i class="fas fa-heart has-text-danger" />
                  </span>
                  <!-- <span class="pre-order"> <i class="fa fa-clock" /> </span> -->
                  <!-- <span class="top-left-corner">
                    <span
                      v-for="s in specialTags(b)"
                      :key="s"
                      class="special-tag"
                      >{{ s }}</span
                    >
                    <span v-if="b.data.award" class="icon">
                      <i class="fa fa-certificate has-text-info" />
                    </span>
                  </span> -->
                  <span v-if="b.distance" class="distance" :class="distanceColor(b.distance)">
                    <span>{{ b.prettyDistance }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="card shop-card" style="background-color: #eee" @click="showClosed = !showClosed">
          <div class="card-content" style="padding: 20px; opacity: 0.9">
            <span class="link">Show Closed Eateries</span>
          </div>
        </div>

        <div ref="bottom">
          <i class="far fa-window-minimize has-text-grey" style="width: 30px; margin-bottom: -15px; padding: 0 0" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import pricing from "@/pricing";
// import geo from "@/geo";

export default {
  name: "EatList",
  props: {
    forceRegion: Boolean,
  },
  data() {
    return {
      //   sortBy: "alphabet",
      search: "", // search
      category: null,
      filter: null, // deprecate
      filters: null, // will be set to an object if filters used
      showClosed: false,
      isBottom: false,
      z: 0,
    };
  },
  computed: {
    isSafari() {
      return (
        this.$store.getters.isSafari ||
        this.$browserDetect.isSafari ||
        this.isIOSApp()
      );
    },
    offsetTopAdjustment() {
      if (this.isSafari) return 200;
      return 50;
    },
    // filter defaults
    cuisines() {
      if (!this.filters) return [];
      return this.filters.cuisineOptions;
    },
    promos() {
      if (!this.filters) return [];
      return this.filters.promoOptions;
    },
    fulfilment() {
      if (!this.filters) return ["delivery"];
      return this.filters.fulfilmentOptions;
    },
    openNowToggle() {
      if (!this.filters) return true;
      return this.filters.openNowToggle;
    },
    distance() {
      if (!this.filters) return 12;
      return this.filters.distance;
    },
    sortBy() {
      if (!this.filters) return "alphabet";
      return this.filters.sortBy;
    },
    openBusinesses() {
      var shops = this.$store.state.eateries; //this.$store.getters.getShops;
      shops = shops.filter((b) => !b.data.hidden); // hide hidden shops from list
      shops = shops.filter((b) => !this.onHoliday(b)); // hide closed for holiday
      shops = shops.filter((b) => this.businessIsOpenNow(b));
      shops = shops.filter((b) => !this.businessIsPaused(b))
      return this.filterAndSort(shops);
    },
    closedBusinesses() {
      var shops = this.$store.state.eateries; //this.$store.getters.getShops;
      shops = shops.filter((b) => !b.data.hidden); // hide hidden shops from list
      shops = shops.filter(
        (b) => !this.businessIsOpenNow(b) || this.onHoliday(b) || this.businessIsPaused(b) // include onHoliday shops in closed
      );
      return this.filterAndSort(shops);
    },
    noBusinesses() {
      if (this.filterAndSort(this.businesses).length == 0) return true;
      return false;
    },
    businesses() {
      this.console("z", this.z);
      var shops = this.$store.state.eateries; //this.$store.getters.getShops;
      shops = shops.filter((b) => !b.data.hidden); // hide hidden shops from list
      return shops;

      //   if (this.search) {
      //     shops = shops.filter((b) => {
      //       if (b.name.toLowerCase().includes(this.search)) return true;
      //       if (
      //         b.data.categories &&
      //         b.data.categories.toLowerCase().includes(this.search)
      //       )
      //         return true;
      //       return false;
      //     });
      //   }

      //   shops = shops.filter((b) => {
      //     if (this.fulfilment.length == 0) return true; // all okay if none specified
      //     if (this.fulfilment.includes("delivery")) {
      //       if (this.isAnyDelivery(b)) return true;
      //     }
      //     if (this.fulfilment.includes("take-away")) {
      //       if (this.isTakeAway(b)) return true;
      //     }
      //     if (this.fulfilment.includes("dine-in")) {
      //       return true;
      //     }
      //   });

      //   shops = shops.filter((b) => {
      //     if (!b.distance || this.forceRegion) return true;
      //     return b.distance < this.distance * 1000; // meters
      //   });

      //   if (this.cuisines.length > 0) {
      //     shops = shops.filter((b) => {
      //       if (!b.data.categories) return false;
      //       var categories = b.data.categories;
      //       for (var i = 0; i < this.cuisines.length; i++) {
      //         if (categories.includes(this.cuisines[i])) return true;
      //       }
      //       return false;
      //     });
      //   }

      //   if (this.openNowToggle) {
      //     shops = shops.filter((b) => {
      //       return this.businessIsOpenNow(b);
      //     });
      //   }

      //   if (this.promos.length > 0) {
      //     shops = shops.filter((b) => {
      //       if (this.promos.includes("free-delivery")) {
      //         if (this.isFreeDelivery(b)) return true;
      //       }
      //     });
      //   }

      //   // after filtering, sort
      //   if (this.sortBy === "alphabet") return this.sortAlphabet(shops, "name");
      //   if (this.sortBy === "distance") return this.sortDistance(shops);
      //   if (this.sortBy === "new") return this.sortCreatedDate(shops);
      //   if (this.sortBy === "favorite") return this.sortFavorite(shops);
      //   return shops; // default
    },
  },
  activated() {
    this.checkScrollBottom();
    this.scrollToPosition();
  },
  deactivated() {
    // this.filters = null; // reset filters here?
  },
  mounted() {
    // EventBus.$on("SHOP_LIST_SORT", (type) => {
    //   this.sortBy = type;
    //   if (type === "filter") this.filter = "Delivery";
    // });
    EventBus.$on("SHOP_LIST_SEARCH", (search) => {
      this.search = search;
      this.checkScrollBottom();
    });
    EventBus.$on("SHOP_LIST_CHANGE", () => {
      this.category = null;
      this.filter = null;
    });
    EventBus.$on("APPLY_EAT_FILTERS", (filters) => {
      this.filters = filters; //   this.z += 1;
      this.checkScrollBottom();
    });
    this.checkScrollBottom();
    this.checkShowClosed();
  },
  methods: {
    checkShowClosed() {
      // if >= n shops are open now then set showClosed=true
      if (this.openBusinesses.length <= 3) this.showClosed = true;
    },
    scrollToPosition() {
      var previousRoute = this.$store.getters.getPreviousRoute;
      if (!previousRoute.includes("/shop/")) return; // don't do it if coming from shop page
      var b = this.$store.state.selectedBusiness;
      if (!b || !this.$refs[b.id]) return; // nothing to scroll to yet
      var el = this.$refs[b.id][0];
      console.log("scrollToPosition", b, el);
      if (el) {
        var opts = { top: el.offsetTop - this.offsetTopAdjustment }; //, behavior: "smooth" };
        this.$refs.scrollable.scrollTo(opts);
      }
    },
    onHoliday(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce || !commerce.data.closed_until) return false;
      return this.isFutureTime(commerce.data.closed_until);
    },
    checkScrollBottom() {
      // console.log("check scroll");
      var el = this.$refs.bottom;
      var bottom = el.getBoundingClientRect().bottom;
      var clientHeight = document.documentElement.clientHeight; // necessary?
      var height = window.innerHeight || clientHeight;
      // console.log("checkScrollBottom", bottom, height);
      if (bottom + 40 < height) this.isBottom = true;
      else this.isBottom = false;
    },
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    tryAgain() {
      this.filters = null;
      this.search = "";
    },
    translateFilter(f) {
      var name = f.toLowerCase().replace(/\s+/g, "-"); // if multi-word how?
      return this.$t(`filter.${name}`);
    },
    businessIsOpenNow(b) {
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" });
      if (b.data.hours_type === "always-open") return true;
      if (!b.data.hours) return true; // unknown hours, say open
      var hours = b.data.hours[today.toLowerCase()];
      if (hours && this.openNow(hours)) return true;
      return false;
    },
    businessIsPaused(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce) return true; // shouldn't be here if not commerce anyway
      return commerce.data.paused;
    },
    filterAndSort(shops) {
      if (this.search) {
        shops = shops.filter((b) => {
          if (b.name.toLowerCase().includes(this.search)) return true;
          if (
            b.data.categories &&
            b.data.categories.toLowerCase().includes(this.search)
          )
            return true;
          return false;
        });
      }

      shops = shops.filter((b) => {
        if (this.fulfilment.length == 0) return true; // all okay if none specified
        if (this.fulfilment.includes("delivery")) {
          if (this.hasDelivery(b)) return true;
        }
        if (this.fulfilment.includes("take-away")) {
          if (this.isTakeAway(b)) return true;
        }
        if (this.fulfilment.includes("dine-in")) {
          return true;
        }
      });

      shops = shops.filter((b) => {
        if (!b.distance || this.forceRegion) return true;
        return b.distance < this.distance * 1000; // meters
      });

      if (this.cuisines.length > 0) {
        shops = shops.filter((b) => {
          if (!b.data.categories) return false;
          var categories = b.data.categories;
          for (var i = 0; i < this.cuisines.length; i++) {
            if (categories.includes(this.cuisines[i])) return true;
          }
          return false;
        });
      }

      if (this.promos.length > 0) {
        shops = shops.filter((b) => {
          if (this.promos.includes("free-delivery")) {
            if (this.isFreeDelivery(b)) return true;
          }
        });
      }

      // after filtering, sort
      if (this.sortBy === "alphabet") return this.sortAlphabet(shops, "name");
      if (this.sortBy === "distance") return this.sortDistance(shops);
      if (this.sortBy === "new") return this.sortCreatedDate(shops);
      if (this.sortBy === "favorite") return this.sortFavorite(shops);
      if (this.sortBy === "foryou") return this.sortForYou(shops);
      return shops; // default
    },
    // translateCategory(c) {
    //   if (!c) return null;
    //   var name = c.toLowerCase().replace(/\s+/g, "-"); // if multi-word how?
    //   return this.$t(`category.${name}`);
    // },
    shopSignUpForm() {
      var url = this.$t("shop.sign-up-form");
      window.open(url, "_blank");
    },
    // updateDistances() {
    //   this.businesses.forEach((b) => {
    //     var coords = this.$store.getters.getUserLatLon;
    //     b.distance = geo.distanceToUserInMeters(coords, b);
    //     b.prettyDistance = geo.prettyDistance(b.distance, 99);
    //   });
    //   this.z += 1; // force update
    // },
    distanceColor(distance) {
      if (distance < 1500) return "color1";
      if (distance < 5000) return "color2";
      if (distance < 10000) return "color3";
      return "color4";
    },
    specialTags(b) {
      if (!b.data.categories) return [];
      var catsStr = b.data.categories;
      var arr = catsStr
        .split(",")
        .map((s) => {
          s = s.trim();
          if (s.endsWith("*")) {
            // var clean = s.replaceAll("*", "").replaceAll("_", "");
            var clean = s.replace(/\*/g, "").replace(/_/g, "");
            return this.capitaliseFirstLetter(clean);
          }
        })
        .filter((s) => s); // remove nulls
      return arr;
    },
    categoryList(b) {
      if (!b.data.categories) return b.business_type;
      //   var cat = b.data.categories.split(",")[0];
      //   return cat;
      var catsStr = b.data.categories;
      var arr = catsStr
        .split(",")
        .map((s) => {
          s = s.trim();
          if (!s.startsWith("_")) return s.replace(/\*/g, ""); //return s.replaceAll("*", "");
        })
        .filter((s) => s);
      return arr.join(", ");
      // this.translateCategory(cat);
    },
    //parseCategories(str) // same as func in ShopInfoTab.vue
    shortName(b) {
      return b.name; // return this.shortenString(b.name, 26);
    },
    commerceWorkflow(b) {
      if (!b.workflows) return false;
      return b.workflows.find((w) => w.workflow_type_name === "Commerce");
      //   return commerce;
    },
    isFreeDelivery(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce) return false;
      if (commerce.data.free_delivery_over) return true; // legacy, also free_delivery_to
      var fruit = commerce.data.fruit;
      return pricing.hasFreeDelivery(fruit);
    },
    isDelivery(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce) return false;
      if (commerce.data.free_delivery) return false;
      if (commerce.data.delivery) return true;
      return false;
    },
    // fix for isDelivery
    hasDelivery(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce) return false;
      if (commerce.data.delivery) return true;
      if (!commerce.data.fulfilment_options) return false;
      return commerce.data.fulfilment_options.includes("delivery");
    },
    isAnyDelivery(b) {
      return this.isDelivery(b) || this.isFreeDelivery(b);
    },
    isTakeAway(b) {
      if (!b.workflows) return false;
      return true;
    },
    sortAlphabet(arr, field) {
      return arr.sort((a, b) => {
        var textA = a[field].toUpperCase();
        var textB = b[field].toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    },
    sortDistance(arr) {
      return arr.sort((a, b) => {
        return a.distance < b.distance ? -1 : a.distance > b.distance ? 1 : 0;
      });
    },
    sortForYou(arr) {
      return arr.sort((a, b) => {
        return a.foryou > b.foryou ? -1 : a.foryou < b.foryou ? 1 : 0;
      });
    },
    sortFavorite(arr) {
      arr = this.sortDistance(arr);
      return arr.sort((a, b) => {
        return this.isFavorite(a.id) > this.isFavorite(b.id)
          ? -1
          : this.isFavorite(a.id) < this.isFavorite(b.id)
            ? 1
            : 0;
      });
    },
    sortCreatedDate(arr) {
      return arr.sort((a, b) => {
        var dateA = new Date(a.created_at);
        var dateB = new Date(b.created_at);
        return dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
      });
    },
    businessProfilePic(b) {
      if (b.profile_pic_url) return b.profile_pic_url;
      return "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png"; // default profile photo
    },
    bannerPic(b) {
      return b.banner_pic_url;
    },
    openShopPage(businessID) {
      this.$store.commit("selectBusiness", businessID);
      this.gotoDelay(`/shop/${businessID}`, 50); // 300ms delay
    },
  },
};
</script>

<style scoped>
.eat-list {
  width: 100vw;
  max-width: 700px;
  margin: auto;
  height: calc(100vh - 125px);
  overflow: hidden;
}

.dark {
  background-color: #123;
  color: white;
}

.dark .card-content {
  /* background-color: rgb(0, 56, 113); */
  background-color: #1f1b24;
  color: white;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.shops-wrapper {
  border-top: 1px solid rgba(68, 68, 68, 0.2);
  overflow-y: scroll;
  height: 100%;
  padding-bottom: 10px;
}

.shop-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100%);
  font-size: 1.15em;
  font-weight: 500;
  /* margin-top: 5px; */
}

.media-left {
  margin-right: 6px;
  /* margin-left: 2px; */
}

.media-content {
  /* margin-top: 12px; */
  margin-top: -2px;
  overflow: hidden;
}

figure img {
  border-radius: 3px;
  object-fit: cover;
  height: 90px;
  width: 90px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.small-img {
  /* height: 47px;
  width: 47px; */
  height: 65px;
  width: 65px;
  margin-top: -2px;
  border-radius: 2px;
  object-fit: cover;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.shop-card {
  cursor: pointer;
}

.shop-card:active {
  transform: scaleY(0.95);
}

/* .shop-card::before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.5);
} */
.sort-by {
  width: 100vw;
  padding-bottom: 12px;
}

.tag {
  padding: 6px;
}

.button {
  padding: 9px;
}

.distance {
  position: absolute;
  right: 8px;
  bottom: 8px;
  text-shadow: 0 0 1px white;
  /* margin-left: -3px; */
  border-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  font-size: 0.85em;
  font-weight: 450;
}

.color1 {
  color: #222 !important;
  /* color: #1a9850 !important; */
}

.color2 {
  color: #555 !important;
  /* color: #91cf60 !important; */
}

.color3 {
  color: #999 !important;
  /* color: #fc8d59 !important; */
}

.color4 {
  color: #ccc !important;
  /* color: #d73027 !important; */
}

.heart {
  position: absolute;
  left: -2px;
  top: -3px;
  text-shadow: 0px 0px 3px white, 0px 0px 3px white, 0px 0px 3px white,
    1px 1px 3px black;
}

.pre-order {
  position: absolute;
  left: 88px;
  top: 0;
  color: rgb(180, 180, 180);
  text-shadow: 0px 0px 3px white, 0px 0px 3px white, 0px 0px 3px white,
    1px 1px 3px black;
}

.bottom-tags {
  margin-top: -2px;
  height: 22px;
}

.delivery-tag {
  background-color: #bbb;
  color: white;
  font-weight: 550;
  border-radius: 2px;
  font-size: 0.8em;
  padding: 0 2px;
}

.free-delivery-tag {
  background-color: #eee;
  color: rgba(255, 105, 180, 0.7);
  font-weight: 550;
  border-radius: 2px;
  font-size: 0.8em;
  padding: 0 2px;
}

.special-tags {
  margin-top: -2px;
  height: 23px;
}

.special-tag {
  background-color: hotpink;
  color: white;
  font-weight: 450;
  border-radius: 2px;
  font-size: 0.75em;
  padding: 0 2px;
  margin-right: 3px;
  margin-top: 3px;
  display: inline-block;
  /* margin-top: 2px; */
  vertical-align: top;
}

.top-left-corner {
  position: absolute;
  /* left: 0; */
  top: 0;
  margin-top: 2px;
}

.top-left-corner .icon {
  height: 1em;
  width: 1em;
  vertical-align: middle;
  /* margin-top: 1px; */
}

.award {
  position: absolute;
  right: 0;
  top: 0;
  margin: 2px;
}

.fast {
  position: absolute;
  right: 22px;
  top: 0;
  margin: 2px;
}

.indicator {
  position: absolute;
  right: 8px;
  bottom: 9px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
}

.closed {
  background-color: rgba(255, 0, 0, 0.4);
}

.open {
  background-color: rgba(19, 223, 19, 0.8);
}

.cannot-find {
  position: relative;
  margin: 10px;
  top: 6px;
  color: grey;
  font-weight: 500;
}

.add-it {
  padding: 16px;
  /* padding-top: 10px; */
  padding-bottom: 28px;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.1);
  bottom: 0;
  width: 100vw;
  max-width: 700px;
  z-index: 0;
}

.no-businesses {
  position: relative;
  margin: 10px;
  /* margin-bottom: 30px; */
  top: 6px;
  font-weight: 500;
  /* display: inline-block; */
}

.single-line {
  white-space: nowrap;
  overflow: auto;
  /* display: inline-block; */
}

.categories {
  color: grey;
  width: 100%;
  margin-top: -4px;
  /* margin-bottom: 2px; */
}

.open-closed-separator {
  opacity: 0.6;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  text-align: left;
  font-weight: 500;
}

.link {
  border-bottom: 1px #ccc dotted;
}

.closed-banner {
  position: absolute;
  /* margin-top: -24px; */
  margin-top: -12px;
  background-color: rgba(187, 187, 187, 0.6);
  /* wdith:90px; */
  width: 70px;
  margin-left: 10px;
  text-align: center;
  border-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  /* color: white; */
  color: black;
  font-weight: 500;
  text-shadow: 0 0 3px white, 0 0 3px white;
  font-size: 0.9em;
  line-height: 1.2em;
  border: 1px solid grey;
}
</style>